import {
  CHANGE_INCIDENT_STATE_REQUEST_ASYNC,
  RESET_REMEDIATION_CONFIRMATION,
} from '../AtoIncident/Header/constants'

import { CLASSIFICATION_MODAL_CLOSE, CLASSIFICATION_MODAL_OPEN } from './constants'

export const openAtoClassificationModal = (newState, incident) => ({
  type: CLASSIFICATION_MODAL_OPEN,
  state: newState,
  incident,
})

const closeAtoClassificationModal = () => ({
  type: CLASSIFICATION_MODAL_CLOSE,
})

const changeIncidentState = (incidentId, newState) => ({
  type: CHANGE_INCIDENT_STATE_REQUEST_ASYNC.INITIATE,
  payload: { incidentId, newState },
})
const resetAtoModalState = () => ({ type: RESET_REMEDIATION_CONFIRMATION })

export default {
  closeAtoClassificationModal,
  changeIncidentState,
  resetAtoModalState,
}
